import store from "store2";

export const AUTH_TOKEN_STORAGE_KEY = "auth_token";
export const AUTH_TOKEN_PARTNER_STORAGE_KEY = "auth_token_partner";
export const USER_PHONE_STORAGE_KEY = "phone";
export const ACTIVE_ENTITY_ID = "activeEntityId";

export const arenzaStorage = store.namespace("arenza");
